import { render } from "./LottieLoader.vue?vue&type=template&id=463efde6&scoped=true"
import script from "./LottieLoader.vue?vue&type=script&lang=js"
export * from "./LottieLoader.vue?vue&type=script&lang=js"

import "./LottieLoader.vue?vue&type=style&index=0&id=463efde6&scoped=true&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463efde6"]])

export default __exports__